const WEB_PROTOCOLS = ['http:', 'https:'];

/**
 * An entity-supplied URL (`metadata.links[].url`, `backstage.io/edit-url`,
 * written by whoever edits catalog-info.yaml) made safe to put in an `href`:
 * the parsed absolute URL if its scheme is `http:` or `https:` (or `mailto:`
 * when `allowMailto`), `undefined` otherwise — relative, unparsable,
 * `javascript:`, `data:`, `vbscript:`… The caller drops the link then.
 *
 * Needed because BUI's ButtonLink renders any `href`, where core-components'
 * `Link`, which the catalog's About and Links cards use, throws on a
 * `javascript:` URL.
 */
export function safeExternalUrl(
  url: string,
  options: { allowMailto?: boolean } = {},
): string | undefined {
  let parsed: URL;
  try {
    // No base: a relative URL throws and is rejected. The WHATWG parser
    // trims surrounding whitespace and lower-cases the scheme.
    parsed = new URL(url.trim());
  } catch {
    return undefined;
  }
  const allowed = options.allowMailto
    ? [...WEB_PROTOCOLS, 'mailto:']
    : WEB_PROTOCOLS;
  return allowed.includes(parsed.protocol) ? parsed.href : undefined;
}
